import * as React from 'react';
// import { RvCard } from '../Card';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { Individual } from '../../matterDetails/parties/PartiesInfo';
import { PartyCard, PartyInfoPanel } from './PartyInfoPanel';
import { PartyCommon, PartyCommonCardProps } from './PartyCommon';

export interface RvContactTableProps extends PartyCommonCardProps {
    data: Individual;
    tableClassName?: string;
    parentTitle?: string;
}

export class RvContactTable extends React.Component<RvContactTableProps, {}>  {

    public render() {
        var infoPanelItems = new Array<{}>();

        PartyCommon.renderCommon(this.props, infoPanelItems, 'inline');
        var showHeader = this.props.parentTitle !== this.props.data.displayName;

        return (
            <PartyCard
                icon={<PersonOutlineIcon />}
                title={showHeader ? this.props.data.displayName : undefined}
                className={this.props.tableClassName}
            >
                <PartyInfoPanel infoItems={infoPanelItems} />
            </PartyCard>
        );
    }
}
